module.exports = __webpack_public_path__ + "static/works-bsl-site-71e8fbb77cfc1fa643994b1207e5ceca.png";